import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const sections = [
  {
    title: 'Introduction',
    content: 'The Ibom Open ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and protect your personal information when you use our website.',
  },
  {
    title: 'Information We Collect',
    content: 'We collect information that you provide directly to us, including:',
    list: ['Name and contact information', 'Registration details for tournaments', 'Payment information', 'Communication preferences'],
  },
  {
    title: 'How We Use Your Information',
    content: 'We use your personal information to:',
    list: ['Process your tournament registrations', 'Send you important updates about the tournament', 'Improve our services and website experience', 'Comply with legal obligations'],
  },
  {
    title: 'Cookies',
    content: 'We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.',
  },
  {
    title: 'Data Security',
    content: 'We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.',
  },
  {
    title: 'Your Rights',
    content: 'Under GDPR, you have the right to:',
    list: ['Access your personal data', 'Correct inaccurate personal data', 'Request erasure of your personal data', 'Object to processing of your personal data', 'Request restriction of processing your personal data', 'Request transfer of your personal data', 'Withdraw consent'],
  },
  {
    title: 'Contact Us',
    content: 'For any questions about this Privacy Policy, please contact us at:\nEmail: privacy@ibomopen.com\nAddress: Ibom Golf & Country Club, Uyo, Akwa Ibom State, Nigeria',
  },
];

export default function MobilePrivacyPolicy() {
  return (
    <div className="pb-10">
      {/* Header */}
      <div className="bg-golf-gray px-4 pt-4 pb-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
            <ShieldCheckIcon className="w-5 h-5 text-golf-orange" />
          </div>
          <h1 className="text-white font-display font-bold text-xl">Privacy Policy</h1>
        </div>
        <p className="text-golf-sand text-xs">Last updated: March 15, 2025</p>
      </div>

      <div className="px-4 pt-4 flex flex-col gap-4">
        {sections.map((section, i) => (
          <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <h2 className="font-display font-bold text-golf-gray text-sm mb-2">{section.title}</h2>
            <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">{section.content}</p>
            {section.list && (
              <ul className="mt-2 space-y-1.5">
                {section.list.map((item, li) => (
                  <li key={li} className="flex items-start gap-2 text-xs text-gray-500">
                    <span className="w-1.5 h-1.5 rounded-full bg-golf-orange mt-1.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}

        <p className="text-center text-xs text-gray-300 mt-2">
          © 2004 – {new Date().getFullYear()} Ibom Open. All rights reserved.
        </p>
      </div>
    </div>
  );
}
